import Header from '@/components/Header';
import { useState } from 'react';
import { Container } from '@/components/ListenPage/Container';
import SearchBar from '@/components/common/SearchBar';
import { MapOfPoland } from '@/components/MapOfPoland';
import FAQ from '@/components/common/FAQ';
import Footer from '@/components/LandingPage/Footer';


export function SearchLayout({ query, setQuery, children }) {

  return (
    <>
      <Header query={query} setQuery={setQuery}></Header>
      <Container>
        <div id="search-desktop" className="text-center bg-white dark:bg-gray-800">
          {children}
          <SearchBar query={query} setQuery={setQuery} />
        </div>
        <div className='mt-40'>
          <div className="py-10 dark:bg-black bg-white w-full">
            <div className="max-w-7xl mx-auto text-center">
              <p className="font-semibold text-xl md:text-4xl dark:text-white text-black">
                Czym jest Lektuarium
              </p>
              <p className="text-sm md:text-lg text-neutral-500 max-w-2xl mx-auto py-4">
                To system, który umożliwia prowadzenie biblioteki prywatnej. Załóż własną, lub skorzystaj z czyjejś w pobliżu.
              </p>
            </div>
          </div>
          <FAQ />
        </div>
        <div>
          <MapOfPoland />
          <Footer />
        </div>
      </Container>

    </>
  );
}
